import React, { useState } from "react";
import { db, storage } from "../../../firebase";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import styles from "./NewsUploadForm.module.css";
import { v4 as uuidv4 } from "uuid"; // 🔥 랜덤 파일명 생성을 위한 UUID

const NewsUploadForm = ({ companyId, setNews }) => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState(""); // SunEditor의 HTML 데이터
  const [isUploading, setIsUploading] = useState(false); // 업로드 상태

  // Firebase Storage로 이미지 업로드하는 함수
  const handleImageUpload = async (file, info, uploadHandler) => {
    console.log("🔥 handleImageUpload 실행됨! 파일명:", file.name);
    setIsUploading(true);
    try {
      // 파일명 충돌 방지를 위해 UUID 추가
      const uniqueFileName = `${uuidv4()}_${file.name}`;
      const storageRef = ref(storage, `news_images/${uniqueFileName}`);
      console.log("🔥 Firebase Storage 업로드 시작!", uniqueFileName);

      // 파일을 Firebase Storage에 업로드
      const snapshot = await uploadBytes(storageRef, file);
      console.log("📂 Firebase Storage 업로드 성공!", snapshot);

      // 업로드된 파일의 URL 가져오기
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log("✅ Firebase Storage URL:", downloadURL);

      // SunEditor에 업로드된 이미지 URL 추가
      uploadHandler({
        result: [{ url: downloadURL, name: file.name, size: file.size }],
      });

      console.log("🖼 SunEditor에 이미지 추가 완료!");
    } catch (error) {
      console.error("❌ Firebase Storage 업로드 실패:", error);
    } finally {
      setIsUploading(false);
    }
  };

  // 뉴스 저장 (Firestore + HTML을 문자열로 변환 후 저장)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !content.trim()) {
      console.error("❌ 제목 또는 내용이 비어 있습니다!");
      return;
    }

    const newNews = {
      title,
      content: JSON.stringify(content), // irestore가 저장할 수 있도록 문자열 변환
      date: new Date().toISOString(),
    };

    try {
      console.log("🔥 Firestore에 저장할 뉴스:", newNews);

      const companyRef = doc(db, "companies", companyId);
      await updateDoc(companyRef, {
        news: arrayUnion(newNews), // 여러 개 뉴스 저장 가능
      });

      console.log("✅ Firestore 저장 완료!");

      setNews((prev) => [...prev, newNews]); // UI 업데이트
      setTitle(""); // 입력 필드 초기화
      setContent(""); // SunEditor 내용 초기화
    } catch (error) {
      console.error("🔥 Firestore 뉴스 등록 실패:", error);
    }
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="뉴스 제목"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
      />

      <SunEditor
        setContents={content}
        onChange={setContent}
        setOptions={{
          height: "auto", // 에디터 높이를 자동으로 조절
          minHeight: "300px", // 최소 높이 설정
          maxHeight: "600px", // 최대 높이 설정(스크롤 필요하면 자동 생성)
          buttonList: [
            ["bold", "italic", "underline", "strike"],
            ["list", "align", "fontSize", "fontColor"],
            ["image", "link"],
          ],
          imageUpload: true, // SunEditor 이미지 업로드 활성화
        }}
        onImageUploadBefore={(files, _, uploadHandler) => {
          console.log("✅ SunEditor에서 이미지 업로드 이벤트 발생!");
          if (!files || files.length === 0) {
            console.log("❌ 업로드할 파일이 없습니다!");
            return;
          }
          console.log("📂 업로드할 파일명:", files[0].name);
          handleImageUpload(files[0], null, uploadHandler);
        }}
      />

      {/* Firestore에 뉴스 저장 */}
      <button type="submit" disabled={isUploading}>
        {isUploading ? "업로드 중..." : "등록"}
      </button>
    </form>
  );
};

export default NewsUploadForm;
